export default [
  {
    path: '/data',
    name: 'data-management',
    beforeEnter(to, from, next) {
      window.open(process.env.VUE_APP_DIRECTUS_BASE_URL, '_blank')
      next(false) // Cancel navigation in the current tab
    },
    meta: {
      resource: 'data',
      action: 'manage',
    },
  },
  {
    path: '/data',
    name: 'data-management-client-admin',
    beforeEnter(to, from, next) {
      window.open(process.env.VUE_APP_DIRECTUS_BASE_URL, '_blank')
      next(false) // Cancel navigation in the current tab
    },
    meta: {
      resource: 'data',
      action: 'manage',
    },
  },
]
